<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useStoreGetters } from 'dashboard/composables/store';

const { t } = useI18n();
const store = useStore();
const getters = useStoreGetters();

const model = defineModel({ type: Object, required: true });

const audiences = computed(() => {
  const records = store.state.audiences.records || [];
  return records.filter(a => a.status === 'active');
});

const contactsCounts = computed(() => store.state.audiences.contactsCounts || {});

const selectAudience = async audience => {
  model.value = { ...model.value, audience };
  if (!contactsCounts.value[audience.id]) {
    await store.dispatch('audiences/fetchContactsCount', audience.id);
  }
};

const isSelected = audience => model.value.audience?.id === audience.id;

onMounted(() => {
  store.dispatch('audiences/get');
});
</script>

<template>
  <div class="max-w-2xl">
    <h2 class="text-base font-medium text-n-slate-12">
      {{ t('CAMPAIGN.V2.WIZARD.AUDIENCE.TITLE') }}
    </h2>
    <p class="mt-1 text-sm text-n-slate-11">
      {{ t('CAMPAIGN.V2.WIZARD.AUDIENCE.DESCRIPTION') }}
    </p>

    <div class="grid gap-3 mt-6">
      <button
        v-for="audience in audiences"
        :key="audience.id"
        class="flex items-center justify-between p-4 text-left border rounded-lg transition-colors"
        :class="
          isSelected(audience)
            ? 'border-n-brand bg-n-brand/5'
            : 'border-n-weak hover:border-n-slate-8'
        "
        @click="selectAudience(audience)"
      >
        <div>
          <div class="font-medium text-n-slate-12">{{ audience.name }}</div>
          <div
            v-if="contactsCounts[audience.id] !== undefined"
            class="text-xs text-n-slate-11 mt-1"
          >
            {{ t('CAMPAIGN.V2.WIZARD.AUDIENCE.CONTACTS_COUNT', { count: contactsCounts[audience.id] }) }}
          </div>
        </div>
        <div
          v-if="isSelected(audience)"
          class="w-5 h-5 rounded-full bg-n-brand flex items-center justify-center"
        >
          <span class="text-white text-xs">&#10003;</span>
        </div>
      </button>
    </div>

    <p
      v-if="audiences.length === 0"
      class="mt-6 text-sm text-n-slate-11"
    >
      {{ t('CAMPAIGN.V2.WIZARD.AUDIENCE.ERROR') }}
    </p>
  </div>
</template>
